import React, { useState, useEffect } from "react";
import { API_IP } from "../global_variables";
import axios from "axios";
import "../styles.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import StarRating from "./UserPatientScreen/StarRating";
import Modal from "./UserCalendarScreen/CalendarMainModal";
import { set } from "date-fns";
import { FaArrowLeft } from "react-icons/fa";
const CareProviderProfile = ({ setSelectedSection }) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isCredentialsOpen, setIsCredentialsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation(); // Curent user location for react router dom.
  const queryParams = new URLSearchParams(location.search);
  const [provider, setProvider] = useState(location.state?.data || null);
  const [loading, setLoading] = useState(!location.state?.data);
  const imgIndex = location.state?.imgIndex || 1;
  const providerName = queryParams.get("name") || "Name";
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const toggleIsRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  // Conditianlly changes the image (direction) for the arrow in the component.
  const profileArrowButton = (setValue) => {
    setValue((prev) => !prev);
  };

  useEffect(() => {
    // Nếu đã có data (do click từ trang trước), không cần làm gì cả
    if (provider) return;

    // Nếu không có data, thử lấy ID từ URL
    const idFromUrl = searchParams.get("id");

    if (idFromUrl) {
      setLoading(true);
      // Gọi API để lấy lại thông tin Provider dựa trên ID
      // LƯU Ý: Nếu backend bạn chưa có API lấy 1 provider,
      // ta có thể gọi API lấy tất cả rồi lọc (hơi thủ công nhưng chắc chắn chạy với code hiện tại của bạn)
      axios
        .get(`${API_IP}/api/providers`)
        .then((response) => {
          // Tìm provider có ID trùng khớp
          const foundProvider = response.data.find(
            (p) => (p._id || p.provider_id) == idFromUrl,
          );

          if (foundProvider) {
            setProvider(foundProvider);
          } else {
            // Không tìm thấy -> Quay về trang chủ
            navigate("/UserHome", { replace: true });
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error refetching provider:", err);
          navigate("/UserHome", { replace: true });
        });
    } else {
      // Không có State, cũng không có ID trên URL -> Quay về trang chủ
      navigate("/UserHome", { replace: true });
    }
  }, [provider, searchParams, navigate]);

  const renderTextWithLineBreaks = (text) => {
    if (!text) return null;
    return text.split("(.)").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split("(.)").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  if (loading || !provider) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
      >
        <img src={require("../images/loading_icon.gif")} alt="Loading..." />
      </div>
    );
  }

  return (
    <>
      <div className="padding3-8">
        <div className="back-button-container">
          <button onClick={handleBackClick} className="profile-back-button">
            <FaArrowLeft className="back-icon" />
            <span>Back to List</span>
          </button>
        </div>
        <Modal
          showModal={showModal}
          handleClose={closeModal}
          preSelectedProvider={provider}
          toggleRefresh={toggleIsRefresh}
          setSelectedSection={setSelectedSection}
        />
        <div></div>
        <div className="profileCard">
          <div className="profileImage">
            <img
              src={
                provider.img_url || require(`../images/avatar_placeholder.png`)
              }
              alt={provider.provider_name}
              className="care-provider-profile-img"
            />
          </div>

          <div className="profileInfo">
            <div className="nameTitle">
              <h1 className="textBlack">{provider.provider_name} </h1>
              <StarRating rating={4} maxStars={5} />
              <h2 className="textBlack textWeight300">{provider.title}</h2>
              <h3 className="profile_slogan">{provider.slogan}</h3>
            </div>

            {/* <div className="eduExperienceContainer">
              <div className="educationContainer">
                <h3>Location</h3>
                <h4 className="textBlack textWeight300">
                  {provider.address}, {provider.city}, {provider.country}
                </h4>
              </div>

              <div className="experienceContainer">
                <h3>Experience</h3>
                <h4 className="textBlack textWeight300">
                  {provider.experience}+ Years
                </h4>
              </div>
            </div> */}

            <div className="scheduleButtonsContainer">
              <button
                className="button scheduleAppointmentButton marginLeft"
                onClick={openModal}
              >
                Schedule an appointment with {provider.provider_name}
              </button>
            </div>
          </div>
        </div>

        <div className="textCard">
          <div
            className={`textCardTitleContainer ${isProfileOpen ? "open" : ""}`}
          >
            <h1 className="textCardTitle">Profile</h1>
            <div className="textCardArrowContainer">
              <button
                id="profileBioToggle"
                className="arrowIconButton"
                onClick={(e) => profileArrowButton(setIsProfileOpen)}
              >
                <img
                  className={`arrowIconButton ${
                    isProfileOpen ? "rotated" : ""
                  }`}
                  src={require("../images/show_more_icon.png")}
                />
              </button>
            </div>
          </div>
          <p
            id="profileBioToggleText"
            className={`textCardBody ${isProfileOpen ? "open" : ""}`}
          >
            {renderTextWithLineBreaks(provider.self_description)}
          </p>
        </div>

        <div className="textCard">
          <div
            className={`textCardTitleContainer ${
              isCredentialsOpen ? "open" : ""
            }`}
          >
            <h1 className="textCardTitle">Credentials</h1>
            <div className="textCardArrowContainer">
              <button
                id="profileCredentialsToggle"
                className={`arrowIconButton ${
                  isCredentialsOpen ? "rotated" : ""
                }`}
                onClick={(e) => profileArrowButton(setIsCredentialsOpen)}
              >
                <img
                  className="arrowIconButton"
                  src={require("../images/show_more_icon.png")}
                />
              </button>
            </div>
          </div>
          <p
            id="profileCredentialsToggleText"
            className={`textCardBody ${isCredentialsOpen ? "open" : ""}`}
          >
            {renderTextWithLineBreaks(provider.credentials)}
          </p>
        </div>

        <div className="textCard">
          <div
            className={`textCardTitleContainer ${isServicesOpen ? "open" : ""}`}
          >
            <h1 className="textCardTitle">Services</h1>
            <div className="textCardArrowContainer">
              <button
                id="profileServicesToggle"
                className={`arrowIconButton ${isServicesOpen ? "rotated" : ""}`}
                onClick={(e) => profileArrowButton(setIsServicesOpen)}
              >
                <img
                  className="arrowIconButton"
                  src={require("../images/show_more_icon.png")}
                />
              </button>
            </div>
          </div>
          <p
            id="profileServicesToggleText"
            className={`textCardBody ${isServicesOpen ? "open" : ""}`}
          >
            {renderTextWithLineBreaks(provider.services_temp)}
          </p>
        </div>
        <div id="profileReviews" className="textCard">
          <h1 className="reviewsTitle">Reviews</h1>
          <StarRating rating={4} maxStars={5} />
          <div className="reviewsBodyContainer">
            {renderTextWithLineBreaks(provider.reviews_temp)}
          </div>
        </div>

        <div className="youMayAlsoLikeContainer">
          <h1>You May Also Like</h1>
        </div>
      </div>
    </>
  );
};

export default CareProviderProfile;
